import { lazy, Suspense } from 'react';

// react-markdown + remark are ~0.2 MB, and descriptions only render after data arrives, so load them on demand.
const Impl = lazy(() => import('./markdown-viewer-impl.jsx'));

function MarkDown(props) {
    return (
        <Suspense fallback={null}>
            <Impl {...props} />
        </Suspense>
    );
}

export { MarkDown };
